import { render, staticRenderFns } from "./MetricNumber.vue?vue&type=template&id=46e71e66&"
import script from "./MetricNumber.vue?vue&type=script&lang=js&"
export * from "./MetricNumber.vue?vue&type=script&lang=js&"
import style0 from "./MetricNumber.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VLayout,
})
